import { Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { HERO_IMAGES } from "../lib/constants";
import { Quote } from "lucide-react";

const STORIES = [
    { name: "Marcus Reed", role: "QB · Lincoln North Star HS", quote: "Digital Beast helped me turn a strong junior season into 5 brand deals and 40K new followers — while keeping my school and family in the loop the whole way.", metric: "+$14,200 in Q1" },
    { name: "Aaliyah Coleman", role: "SG · Omaha Central HS", quote: "They built me a media kit, produced a launch reel and closed my first major sneaker deal. My audience doubled in 4 months.", metric: "2.1x follower growth" },
    { name: "Deion Brooks", role: "WR · UNL", quote: "The pitch decks Digital Beast made got me in front of 3 national brands. This is a real agency operation, not just a website.", metric: "3 new brand partners" },
];

export default function SuccessStories() {
    return (
        <PageLayout>
            <section className="pt-32 pb-14 border-b border-white/10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Success Stories</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="stories-heading">
                        THE <span className="text-[#d4af37]">RECEIPTS.</span>
                    </h1>
                </div>
            </section>
            <section className="py-16 md:py-24">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 space-y-6">
                    {STORIES.map((s) => (
                        <div key={s.name} className="surface p-8 md:p-10 grid md:grid-cols-12 gap-6 items-start" data-testid={`story-${s.name.toLowerCase().replace(/\s+/g,'-')}`}>
                            <div className="md:col-span-3">
                                <div className="font-display text-2xl text-white">{s.name}</div>
                                <div className="text-white/50 text-xs uppercase tracking-widest mt-2">{s.role}</div>
                            </div>
                            <div className="md:col-span-6 border-l border-white/10 pl-6">
                                <Quote className="text-[#d4af37] mb-3" size={22} />
                                <p className="text-white/80 leading-relaxed text-lg">"{s.quote}"</p>
                            </div>
                            <div className="md:col-span-3 text-right">
                                <div className="font-display text-[#d4af37] text-4xl">{s.metric}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-center mt-16">
                    <Link to="/apply" className="btn-gold" data-testid="stories-apply">Write Your Own Story</Link>
                </div>
            </section>
        </PageLayout>
    );
}
